import React from "react";
import "./Menu-item.styles.scss";
import { withRouter } from "react-router-dom";

const MenuItem = ({ title, img, size, onClick, availability }) => (
  <div className={`${size} menu-item`} onClick={onClick}>
    <div
      className="background-image"
      style={{
        backgroundImage: `url(${img})`,
      }}
    />
    <div className="content">
      <h1 className="title">{title.toUpperCase()}</h1>
      <span className="subtitle">{availability}</span>
    </div>
  </div>
);

export default withRouter(MenuItem);
